import { createAcceptInvitationValidator, createCreateInvitationValidator, createResendInvitationValidator, } from "#validators/invitations.validator.factory";
// Use factory functions with pass-through translation for type inference
const createInvitationValidatorForType = createCreateInvitationValidator((key) => key);
const acceptInvitationValidatorForType = createAcceptInvitationValidator((key) => key);
const resendInvitationValidatorForType = createResendInvitationValidator((key) => key);
